export const socialsData = {
    github: 'https://github.com/WhoAbdullahSheikh',
    twitter: 'https://x.com/_IamAbdullahS',
    stackOverflow: 'https://stackoverflow.com/users/21792851/muhammad-abdullah',
    linkedIn: 'https://www.linkedin.com/in/muhammadabdullahdotdev',

}